import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineContent,
  TimelineDot,
  timelineItemClasses,
} from '@mui/lab'
import { Button, Popover, Stack, Typography, Box } from '@mui/material'
import { OverlayState } from '@/hooks/useOverlay'
import { ProjectGridField } from '@/types/fields'
import { VendorLiveListEntity } from '@/types/live-lists'
import useFieldValue from '../validation/useFieldValue'

type UpdateVendorPopoverProps = {
  overlay: OverlayState
  suggestedVendor: VendorLiveListEntity
  vendorData: {
    value: string | null
    field: ProjectGridField
  }
}

export default function UpdateVendorPopover({
  overlay,
  vendorData,
  suggestedVendor,
}: UpdateVendorPopoverProps) {
  const { onManualChange } = useFieldValue({
    field: vendorData.field,
  })

  return (
    <Popover
      open={overlay.isOpen}
      anchorEl={overlay.anchorEl as Element}
      onClose={overlay.close}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          sx: {
            p: 2,
            minWidth: 320,
          },
        },
      }}
    >
      <Typography variant="subtitle1">
        Update invoice vendor to match PO?
      </Typography>

      <Timeline
        sx={{
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
          p: 1,
          pb: 0,
        }}
      >
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot />
            <Box
              sx={{
                flexGrow: 1,
                ml: '1px',
                borderRight: '2px dashed',
                borderColor: 'text.disabled',
              }}
            />
          </TimelineSeparator>
          <TimelineContent sx={{ '&.MuiTimelineContent-root': { mt: -1.5 } }}>
            <Typography
              color="text.disabled"
              variant="overline"
              sx={{
                fontWeight: 'bold',
                lineHeight: 1.75,
              }}
            >
              Current Vendor
            </Typography>
            <Typography
              color="text.disabled"
              sx={{
                textDecoration: 'line-through',
              }}
            >
              {vendorData.value || 'Unknown Vendor'}
            </Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="primary" />
          </TimelineSeparator>
          <TimelineContent sx={{ '&.MuiTimelineContent-root': { mt: -1.5 } }}>
            <Typography
              color="primary"
              variant="overline"
              sx={{
                fontWeight: 'bold',
                lineHeight: 2,
              }}
            >
              New Vendor
            </Typography>
            <Typography>{suggestedVendor.pd_display_name}</Typography>
          </TimelineContent>
        </TimelineItem>
      </Timeline>

      <Stack direction="row" spacing={1} justifyContent="flex-end">
        <Button variant="text" onClick={overlay.close}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            onManualChange(
              {
                manualValue: suggestedVendor.pd_display_name,
                jsonObject: suggestedVendor,
              },
              true,
            )
            overlay.close()
          }}
        >
          Update vendor
        </Button>
      </Stack>
    </Popover>
  )
}
